import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent,
    Popper,
    Grow,
    TextField,
    InputAdornment,
    Checkbox,
    Button,
    Divider
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import { connect } from "react-redux";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
    searchInput: {
        width: "92%",
    },
    searchInputInside: {
        padding: "15px 14px"
    },
    filterButton: {
        backgroundColor: "#fff",
        // margin: "0 3px",
        borderRadius: 30,
        textTransform: "capitalize",
        padding: "5px 10px"
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'flex-start', fontWeight: 300, paddingLeft: 0
    },
    arrowDropDownIconV1: {
        marginTop: -3
    },
    selectAll: {
        color: "blue",
        margin: "7px 0",
        fontWeight: 600,
        cursor: 'pointer',
        paddingLeft: 9
    },
    deSelectAll: {
        color: "red",
        margin: "7px 0",
        fontWeight: 600,
        cursor: 'pointer',
        paddingLeft: 9
    },
    wV1: {
        width: '100%',
        textAlign: 'center'
    },
    wV2: {
        width: '100%'
    },
    buttonV1: {
        color: 'white', backgroundColor: 'black', textTransform: 'capitalize', borderRadius: 4, fontSize: 15, height: '3em', width: '100%', fontWeight: 'bold',
        "&:hover": {
            backgroundColor: 'black'
        }
    },
}));

const PartySupplierFilter = ({ user, type, onCheck, defaultValue }) => {

    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState([]);
    const [listValues, setListValues] = useState([]);
    const [searchedValue, setSearchedValue] = useState(null);
    const [disableConfirm, setDisableConfirm] = useState(false);

    const anchorRef = useRef(null);
    const prevOpen = useRef(open);

    const classes = useStyles();

    useEffect(() => {
        const all = [];

        if (type == "party" && user.allParties) {
            setListValues(user.allParties);
            if (defaultValue && defaultValue.length > 0) {
                setChecked(defaultValue);
            } else {
                user.allParties.map((value, index) => {
                    all.push(value.customerId)
                });
                setChecked(all);
            }
        } else if (type == "supplier" && user.allVendors) {
            setListValues(user.allVendors)
            if (defaultValue && defaultValue.length > 0) {
                setChecked(defaultValue);
            } else {
                user.allVendors.map((value, index) => {
                    all.push(value.id)
                });
                setChecked(all);
            }
        }

    }, [user.allParties, user.allVendors, defaultValue]);

    const selectAll = () => {
        const all = [];

        if (type == "party" && user.allParties) {
            user.allParties.map((value, index) => {
                all.push(value.customerId)
            });
        } else if (type == "supplier" && user.allVendors) {
            user.allVendors.map((value, index) => {
                all.push(value.id)
            });
        }

        setDisableConfirm(false);
        setChecked(all);
    }

    const deSelectAll = () => {
        setChecked([]);
        setDisableConfirm(true);
    }

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        if (newChecked.length == 0) {
            setDisableConfirm(true);
        } else {
            setDisableConfirm(false);
        }

        setChecked(newChecked);

    };

    const handleFilterOpen = () => {
        setOpen(true)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }

    const onSearch = (e) => {
        setSearchedValue(e.target.value);
        let search = e.target.value;
        let list;
        if (type == "party") {
            list = user.allParties.filter(x => x.name.toLowerCase().includes(search.toLowerCase()));
        } else if (type == "supplier") {
            list = user.allVendors.filter(x => x.vendorName.toLowerCase().includes(search.toLowerCase()));
        }
        setListValues(list);
    }

    const handleConfirm = () => {
        if (checked.length > 0) {
            onCheck(checked);
            setOpen(false)
        }
    }

    return (
        <>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                variant="outlined"
                size="small"
                className={classes.filterButton}
                onClick={handleFilterOpen}
            >
                {type == "party" &&
                    <>
                        {(checked.length === 0 || checked.length === user.allParties.length) ? "All Parties" : ""}
                        {(checked.length > 0 && checked.length != user.allParties.length) ? checked.length == 1 ? "1 Party" : checked.length + " Parties" : ""}
                    </>
                }
                {type == "supplier" &&
                    <>
                        {(checked.length === 0 || checked.length === user.allVendors.length) ? "All Suppliers" : ""}
                        {(checked.length > 0 && checked.length != user.allVendors.length) ? checked.length == 1 ? "1 Supplier" : checked.length + " Suppliers" : ""}
                    </>
                }
                <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
            </Button>

            {
                open &&
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000, marginTop: 4 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper >
                                <ClickAwayListener onClickAway={handleClose}>

                                    <div>
                                        <div className={classes.wV1}>
                                            <TextField
                                                type="search"
                                                className={classes.searchInput}
                                                variant="outlined"
                                                placeholder={type == "party" ? 'Search Parties' : 'Search Suppliers'}
                                                onChange={(e) => onSearch(e)}
                                                margin="normal"
                                                inputProps={{
                                                    className: classes.searchInputInside
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon style={{ color: 'grey' }} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </div>
                                        <div style={{ height: '16.5em', overflow: 'auto' }}>
                                            <MenuList autoFocusItem={open} id="menu-list-grow">
                                                <div style={{ overflow: 'auto' }}>
                                                    <div>
                                                        {checked && checked.length >= 0 && checked.length != (type == "party" ? user?.allParties.length : user?.allVendors.length) && <div className={classes.selectAll} onClick={selectAll}>
                                                            Select All
                                                        </div>}
                                                        {checked && checked.length != 0 && checked.length === (type == "party" ? user?.allParties.length : user?.allVendors.length) && <div onClick={deSelectAll} variant="p" className={classes.deSelectAll}>
                                                            Deselect All
                                                        </div>}
                                                    </div>
                                                    {type == "party" &&
                                                        <>
                                                            {listValues.map((value, index) => (
                                                                <div className={classes.wV2}>
                                                                    <MenuItem key={index} className={classes.menuItemV1}>
                                                                        <Checkbox
                                                                            edge="end"
                                                                            onChange={handleToggle(value.customerId)}
                                                                            checked={checked.indexOf(value.customerId) !== -1}
                                                                            inputProps={{ 'aria-labelledby': value.name }}

                                                                        />
                                                                        <div style={{ marginLeft: 6 }}>{value.name}</div>
                                                                    </MenuItem>
                                                                    <Divider light />
                                                                </div>
                                                            ))}
                                                        </>
                                                    }

                                                    {type == "supplier" &&
                                                        <>
                                                            {listValues.map((value, index) => (
                                                                <div className={classes.wV2}>
                                                                    <MenuItem key={index} className={classes.menuItemV1} >
                                                                        <Checkbox
                                                                            edge="end"
                                                                            onChange={handleToggle(value.id)}
                                                                            checked={checked.indexOf(value.id) !== -1}
                                                                            inputProps={{ 'aria-labelledby': value.vandorName }}
                                                                        />
                                                                        <div style={{ marginLeft: 6 }}>{value.vendorName}</div>
                                                                    </MenuItem>
                                                                    <Divider light />
                                                                </div>
                                                            ))}
                                                        </>
                                                    }
                                                </div>

                                                {/* <Button>
                                            Confirm
                                        </Button> */}
                                            </MenuList>
                                        </div>
                                        <div>
                                            <Button className={classes.buttonV1} variant="contained" onClick={() => handleConfirm()} disabled={disableConfirm}>
                                                Confirm
                                            </Button>
                                        </div>
                                    </div>

                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartySupplierFilter);